import { IBODetailsCard } from "./IBODetailsCard";

export default IBODetailsCard;
